export default {
  bind(el, bindings, vnode) {
    let timeout = 500
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(() => {
        
        el.classList.add('active')
      }, timeout)
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/directives/fade-in/fade-in.js